export enum AliasType {
  Product = 'Product',
  Category = 'Category',
}
